import * as React from 'react';
import { checkMapId } from '../../../../../../api/Engrain';
import FormInput from '../../../../../common/form/Input';
import { Col, Row } from 'reactstrap';
import Button from '../../../../../common/form/Button';
import { useEffect, useState } from 'react';

interface Props {
    errorMessage?: string;
    setError: (error?: string) => void;
    setIsValid: (isLoading: boolean) => void;
    setMapId: (mapId: string) => void;
    mapId: string;
    isValid: boolean;
    disabled: boolean;
}

const MapIdEnterInput = (props: Props) => {
    const [inputId, setInputId] = useState(props.mapId);
    const handleUpdateId = async () => {
        props.setIsValid(false);
        if (inputId === undefined || inputId.length === 0) {
            props.setIsValid(false);
            props.setError('No map Id specified');
            return;
        }
        let result = await checkMapId(inputId);
        if (result) {
            props.setError('');
            props.setMapId(inputId);
            return;
        }
        props.setError('Map not found');
        return;
    };
    useEffect(() => {
        handleUpdateId();
    }, []);
    return (
        <Row>
            <Col>
                <FormInput
                    labelProps={{
                        labelText: 'Map Id',
                        invalidText: 'Please enter a map Id'
                    }}
                    inputProps={{
                        id: 'unitmap-id',
                        name: 'mapId',
                        value: inputId,
                        type: 'string',
                        required: true,
                        disabled: props.disabled
                    }}
                    onChange={(_name, value) => {
                        setInputId(value.toString());
                    }}
                />
            </Col>
            <Col>
                <Button disabled={!inputId || props.disabled} text="Load Map" onClick={handleUpdateId} />
            </Col>
        </Row>
    );
};

export default MapIdEnterInput;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/unitMapControls/MapIdEnterInput.tsx